/**
 * Activity Feed Types
 * Matches backend DTOs from ActivityController
 */

export interface ActivityUser {
  id: number;
  username: string;
  avatarUrl: string | null;
  countryCode: string | null;
  isElite?: boolean;
  showAnimatedBorder?: boolean;
  borderColor1?: string | null;
  borderColor2?: string | null;
}

export interface ActivityCard {
  id: number;
  name: string;
  scryfallId: string;
  imageUrl: string; // Full CDN URL from backend - use directly
  setCode: string;
  foil: boolean;
}

export type ActivityType = 'trade_sent' | 'trade_received' | 'want_added' | 'card_added' | 'trade_shipped';

export interface Activity {
  id: string; // Format: ${type}_${sourceId}_${itemIndex}
  type: ActivityType;
  createdAt: string; // ISO timestamp
  user: ActivityUser;
  card: ActivityCard;
  pointValue: number | null; // null → show "???"
}

export interface RecentActivityResponse {
  activities: Activity[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface RecentActivityRequest {
  limit?: number;
  cursor?: string;
}

/**
 * Activity Stats - Live Pulse Dashboard
 * Matches backend ActivityStatsResponse from GET /activity/stats
 */
export interface ActivityStats {
  tradesLastHour: number;
  packagesShippedToday: number;
  cardsTradedThisWeek: number;
}

/**
 * Get display text for activity type
 */
export const getActivityActionText = (type: ActivityType): string => {
  switch (type) {
    case 'trade_sent':
      return 'sent:';
    case 'trade_received':
      return 'received:';
    case 'want_added':
      return 'wants:';
    case 'card_added':
      return 'added:';
    case 'trade_shipped':
      return 'shipped:';
    default:
      return '';
  }
};
